import ViewTable from './ViewTable';

const DuplicateViewTable = ({ dataTable, isFreshness, isContinuation }) => {
    const heads = [
        {
            title: 'JAN',
            field: 'jan',
            className: 'v-base_minWidth--95 v-base_width--6',
        },
        {
            title: '商品名',
            field: 'itemName',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        !isContinuation && {
            title: '売価種別',
            field: 'lowestPriceTypeName',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        !isContinuation && {
            title: '定番売価\n非会員価格',
            field: 'discountedEdlpSellingPrice',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        !isFreshness && {
            title: '現在の会員価格\n非会員価格',
            field: 'discountedLowestSellingPrice',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        {
            title: !isFreshness ? '競合店売価\n非会員価格' : '鮮度起因値下げ\n非会員価格',
            field: 'sellingPrice',
            className: 'v-base_minWidth--115 v-width-auto',
        },
    ];

    const body = {
        columns: [
            {
                field: 'jan',
            },
            {
                field: 'itemName',
                className: 'text-left',
            },
            !isContinuation && {
                field: 'lowestPriceTypeName',
            },
            !isContinuation && {
                // テーブルでは更徳と比較して安い金額を表示
                field: 'discountedEdlpSellingPrice',
                duoField: 'edlpSellingPrice',
            },
            !isFreshness && {
                field: 'discountedLowestSellingPrice',
                duoField: 'lowestSellingPrice',
            },
            {
                field: 'discountedRequestSellingPrice',
                duoField: 'requestSellingPrice',
                colorRed: true,
            },
        ],
    };

    return <ViewTable heads={heads} body={body} dataTable={dataTable} />;
};

export default DuplicateViewTable;
